export default __webpack_public_path__ + "static/ISO-27001-ab458bcf8dbd6698a975e0e9e1153176.png";